import { j as s } from "./kezios-design-system.esm172.js";
import { IconComponent as a } from "./kezios-design-system.esm4.js";
const r = (t) => /* @__PURE__ */ s.jsxs(a, { ...t, viewBox: "0 0 21 22", children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#a)", children: [
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "url(#b)",
        d: "M11.147 12.19c-.48 0-4.795-.16-4.795-5.172a.528.528 0 0 0-.519-.518c-.28 0-.52.238-.52.518C5.314 12.03 1 12.19.52 12.19H.48c-.28.04-.479.238-.479.517 0 .278.24.517.52.517.519 0 4.794.159 4.794 5.172 0 .278.24.517.52.517.24.08.479-.159.479-.477 0-5.014 4.315-5.172 4.794-5.172h.04c.28 0 .52-.239.52-.557a.528.528 0 0 0-.52-.517Z"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "url(#c)",
        d: "M7.67 2.834c.096 0 .179-.082.179-.192a.182.182 0 0 0-.18-.178c-.165 0-1.656-.055-1.656-1.785A.182.182 0 0 0 5.833.5a.182.182 0 0 0-.179.179c0 1.73-1.49 1.785-1.656 1.785h-.014c-.097.013-.166.082-.166.178 0 .096.083.179.18.179.18 0 1.656.054 1.656 1.785 0 .096.083.178.18.178.082.014.165-.068.165-.165 0-1.73 1.49-1.785 1.656-1.785h.014Z"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "url(#d)",
        d: "M19.49 18.963a.242.242 0 0 0 .237-.25.238.238 0 0 0-.236-.232c-.218 0-2.18-.071-2.18-2.32a.238.238 0 0 0-.236-.232.238.238 0 0 0-.236.232c0 2.25-1.961 2.32-2.18 2.32h-.017c-.127.018-.218.107-.218.232s.109.232.236.232c.236 0 2.18.072 2.18 2.321 0 .125.108.232.235.232.11.018.218-.089.218-.214 0-2.25 1.962-2.32 2.18-2.32h.018Z"
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "mask",
      {
        id: "f",
        width: "20",
        height: "21",
        x: "3.516",
        y: "0",
        fill: "#000",
        maskUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M3.516 0h20v21h-20z" }),
          /* @__PURE__ */ s.jsx("path", { d: "M20.926 10.256c-.063-.128-.22-.192-.345-.224-.722 0-6.93-.255-6.93-7.616A.42.42 0 0 0 13.244 2a.42.42 0 0 0-.406.416c0 7.36-6.208 7.616-6.898 7.616a.351.351 0 0 0-.251.096c-.063.032-.094.096-.125.128a.482.482 0 0 0 0 .416c.062.129.219.224.376.224h.031c.721 0 6.898.256 6.898 7.616a.42.42 0 0 0 .408.417.42.42 0 0 0 .407-.416c0-7.329 6.176-7.617 6.898-7.617.157 0 .282-.095.376-.224a.403.403 0 0 0-.031-.416Z" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "url(#e)",
        d: "M20.926 10.256c-.063-.128-.22-.192-.345-.224-.722 0-6.93-.255-6.93-7.616A.42.42 0 0 0 13.244 2a.42.42 0 0 0-.406.416c0 7.36-6.208 7.616-6.898 7.616a.351.351 0 0 0-.251.096c-.063.032-.094.096-.125.128a.482.482 0 0 0 0 .416c.062.129.219.224.376.224h.031c.721 0 6.898.256 6.898 7.616a.42.42 0 0 0 .408.417.42.42 0 0 0 .407-.416c0-7.329 6.176-7.617 6.898-7.617.157 0 .282-.095.376-.224a.403.403 0 0 0-.031-.416Z"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        stroke: "#fff",
        strokeWidth: "4",
        d: "M20.926 10.256c-.063-.128-.22-.192-.345-.224-.722 0-6.93-.255-6.93-7.616A.42.42 0 0 0 13.244 2a.42.42 0 0 0-.406.416c0 7.36-6.208 7.616-6.898 7.616a.351.351 0 0 0-.251.096c-.063.032-.094.096-.125.128a.482.482 0 0 0 0 .416c.062.129.219.224.376.224h.031c.721 0 6.898.256 6.898 7.616a.42.42 0 0 0 .408.417.42.42 0 0 0 .407-.416c0-7.329 6.176-7.617 6.898-7.617.157 0 .282-.095.376-.224a.403.403 0 0 0-.031-.416Z",
        mask: "url(#f)"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "b",
        x1: "11.206",
        x2: "2.339",
        y1: "18.462",
        y2: "8.625",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#FFC83A" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#EB5B26" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "c",
        x1: "4.067",
        x2: "7.502",
        y1: ".809",
        y2: "3.242",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#EB5B26" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#FFC83A" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "d",
        x1: "14.751",
        x2: "19.234",
        y1: "16.33",
        y2: "19.545",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#EB5B26" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#FFC83A" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "e",
        x1: "17.086",
        x2: "5.535",
        y1: "10.577",
        y2: "10.954",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#EB5B26" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#FF6F3A" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx("clipPath", { id: "a", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 .5h21v21H0z" }) })
  ] })
] });
export {
  r as IconStars
};
